/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExchangeTokenRequest } from '../models/ExchangeTokenRequest';
import type { SuccessLoginResponse } from '../models/SuccessLoginResponse';
import type { SuccessTranscarentMemberAccessResponse } from '../models/SuccessTranscarentMemberAccessResponse';
import type { TranscarentMemberAccessRequest } from '../models/TranscarentMemberAccessRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TranscarentSsoControllerService {

    /**
     * Exchanges temporary token with a refresh and access tokens
     * @param requestBody
     * @returns SuccessLoginResponse OK
     * @throws ApiError
     */
    public static exchangeToken(
        requestBody: ExchangeTokenRequest,
    ): CancelablePromise<SuccessLoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/integrations/transcarent/exchange',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

    /**
     * Accepts data from transcarent, creates/updates a user in 9amHealth and returns the 9amHealth user ID with exchange token.
     * @param clientIpAddress
     * @param requestBody
     * @returns SuccessTranscarentMemberAccessResponse OK
     * @throws ApiError
     */
    public static accessToken(
        clientIpAddress: string,
        requestBody: TranscarentMemberAccessRequest,
    ): CancelablePromise<SuccessTranscarentMemberAccessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/integrations/transcarent/access',
            query: {
                'clientIpAddress': clientIpAddress,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
